import { Button } from "@chakra-ui/react";
import React from "react";

function SubmitButton({ loadingText, id, type, label, size, bg, color }) {
  return (
    <>
      <Button
        loadingText={loadingText}
        id={id}
        type={type}
        size={size}
        bg={bg}
        color={color}
      >
        {label}
      </Button>
    </>
  );
}

export default SubmitButton;
